import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgIconComponent, provideIcons } from '@ng-icons/core';

import { icons, menu } from './menu';

@Component({
  selector: 'mw-navigation-menu',
  standalone: true,
  imports: [NgIconComponent, RouterModule],
  providers: [provideIcons({ ...icons })],
  templateUrl: './navigation-menu.component.html',
  styleUrl: './navigation-menu.component.scss'
})
export class NavigationMenuComponent {
  readonly menu = menu;
}
